<template>
  <tbody class="border-1 fs-small lh-md">
    <tr
      v-for="(schedule, key) in schedules"
      :key="key"
      :id="[schedule.isInitialize === true && isDaily === true ? anchor : '']"
      :class="schedule.statusClass.trClass"
    >
      <TableData :schedule="schedule" :isMobile="isMobile"></TableData>
    </tr>
  </tbody>
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
/* Import Compoments. */
import TableData from "./tableData.vue";
/* Import Scripts. */
/* Import Variables */
import { anchor } from "../../../../compositions/variables";
export default defineComponent({
  props: {
    schedules: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    isDaily: {
      type: Boolean,
      required: true,
      default() {
        return false;
      },
    },
    isMobile: {
        type: Boolean,
      required: true,
      default() {
        return false;
      },
    }
  },
  components: {
    TableData,
  },
  setup(props: { schedules: any; isDaily: Boolean; isMobile: Boolean}) {
    const schedules = props.schedules;
    const isDaily = props.isDaily;
    const isMobile = props.isMobile;
    return {
      /* valiables */
      schedules,
      isDaily,
      isMobile,
      anchor,
      /* script */
    };
  },
});
</script>
